import Router from './router/Router';
import './common.scss';

function App() {
	return <Router></Router>;
}

export default App;